import { render, staticRenderFns } from "./UcRentalSelector.yaml?vue&type=template&id=3960dc41&component"
import script from "./UcRentalSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcRentalSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports